import { render, staticRenderFns } from "./pc2.vue?vue&type=template&id=e99d53a4&"
import script from "./pc2.vue?vue&type=script&lang=js&"
export * from "./pc2.vue?vue&type=script&lang=js&"
import style0 from "./pc2.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports